// extracted by mini-css-extract-plugin
export default {"container":"LmHfhUJ3ckQRsREKBt3u","page-button":"Dbf4p5es90jSqGkZEF3p","active":"re1J0rqeL4I5hIzbFhDC","arrow":"YWrrZUgs_gURjOqNcGNO"};